// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Table, Tag } from 'antd';
import { GLOBAL_TABLE_SIZE } from 'global_config/constant-global';


class UserRightsTable extends React.Component {

	render() {
		const { data, pageSize, loading = false, onRowDblClick, onTableChange, currentPage } = this.props;

		const columns = [
			{
				title: 'USER TYPE',
				dataIndex: 'userType',
				width: 200,
				sorter: (a, b) => { return a.userType.localeCompare(b.userType) },
				
			},
			{
				title: 'DESCRIPTION',
				dataIndex: 'typeDescription',
				width: 450,
				
			},
			{
				title: 'DATE CREATED',
				dataIndex: 'dateTimeCreated',
				width: 200,
			},
			{
				title: 'STATUS',
				dataIndex: 'active',
				width: 120,
				render: active => (
					<Tag color={active === 0 ? "red" : "green"}>
						{active === 0 ? 'INACTIVE' : 'ACTIVE'}
					</Tag>
				)
			}
		];

		return (
			<div style={{ marginTop: 20 }} className="settings-exam-item-table">
				<Spin spinning={loading} tip="Loading...">
					<Table
						size={GLOBAL_TABLE_SIZE}
						tableLayout="fixed"
						scroll={{ x: 1020 }}
						pagination={{
							pageSize,
							current: currentPage
						}}
						columns={columns}
						dataSource={data}
						rowKey={record => record.userTypeID}
						onChange={onTableChange}
						onRow={(record) => {
							return {
								onDoubleClick: () => onRowDblClick(record)
							};
						}}
					/>
				</Spin>
			</div>
		);
	}
}


UserRightsTable.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		userTypeID: PropTypes.number,
		userType: PropTypes.string,
		active: PropTypes.number,
		dateCreated: PropTypes.string
	})).isRequired,
	pageSize: PropTypes.number.isRequired,
	loading: PropTypes.bool.isRequired,
	onRowDblClick: PropTypes.func.isRequired,
	onTableChange: PropTypes.func,
	currentPage: PropTypes.number
};

export default UserRightsTable;